const timeline = [
  {
    title: "State Engineer in Computer Science",
    period: "2024 - Present",
    organization: "Higher National School of Computer Science (ESI), Algiers",
    description:
      "Currently pursuing engineering studies with focus on software foundations, data structures, and practical systems development."
  },
  {
    title: "Internship Funding Management Platform",
    period: "Feb 2026 - Jun 2026",
    organization: "Internship Project",
    description:
      "Contributed to building a nationwide platform that streamlines researcher internship funding workflows for education institutions."
  }
];

const activities = [
  "Active member at ETIC Club Algiers",
  "Active member at School of AI Algiers",
  "Participant in School of AI Camp",
  "Participant in Ideathon"
];

function Journey() {
  return (
    <section id="journey">
      <div className="container">
        <h1>Education & Experience</h1>
        <hr />
        <div className="timeline-grid">
          {timeline.map((item) => (
            <article key={item.title} className="timeline-card">
              <span className="period">{item.period}</span>
              <h3>{item.title}</h3>
              <h4>{item.organization}</h4>
              <p>{item.description}</p>
            </article>
          ))}
        </div>

        <div className="activity-block">
          <h2>Activities</h2>
          <ul>
            {activities.map((activity) => (
              <li key={activity}>{activity}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Journey;
